import { Alert } from './Alert'
import { useAlert } from '../../context/AlertContext'

export const AlertContainer = () => {
  const { message, status, isVisible, setIsVisible, dismissable, data } = useAlert()
  const close =  () => { setIsVisible(false) }
  const onClose = dismissable ? close : undefined
  
  return <Alert isOpen={isVisible} onClose={onClose} message={message || ''} variant={status} data={data} />
}
